import React, {Fragment, useState, useEffect} from 'react';
import {Modal, Tooltip, Button, Form, Input, Select} from 'antd';
import {PlusCircleOutlined} from '@ant-design/icons';

export function AddModelDialog({onAddModel, disabled}) {
    const [visible, setVisible] = useState();
    const [currentType, setCurrentType] = useState('object');
    const [currentModelType, setCurrentModelType] = useState();
    const [form] = Form.useForm();

    const supportedTypes = ['object', 'combined'];

    const initialValues = {
        name: '',
        type: 'schema',
        schemaType: 'object',
    };

    async function handleOk() {
        try {
            const values = await form.validateFields();
            console.log('model values', values);
            onAddModel(values);
        } catch (err) {
            console.error(err);
        }
    }

    const handleTypeChange = (newType) => {
        setCurrentType(newType);
        if (newType !== 'combined') {
            form.setFieldsValue({operator: null});
        } else {
            form.setFieldsValue({operator: 'allOf'});
        }
    };

    const handleModelTypeChange = (newType) => {
        setCurrentModelType(newType);
        if (newType !== 'schema') {
            form.setFieldsValue({operator: null, schemaType: 'object'});
        }
    };

    useEffect(() => {
        setCurrentModelType('schema');
        setCurrentType('object');
    }, []);

    return (
        <Fragment>
            <Tooltip title="Add New Model">
                <Button className="addModel" id="addModel" disabled={disabled} type="link" size="small" onClick={() => setVisible(true)} icon={<PlusCircleOutlined />} />
            </Tooltip>
            {visible && (
                <Modal
                    title="Add New Model"
                    open={visible}
                    closable={false}
                    onCancel={() => setVisible(false)}
                    footer={[
                        <Button key="cancel" className="addRef" onClick={() => setVisible(false)}>
                            Cancel
                        </Button>,
                        <Button key="submit" className="addField" type="primary" onClick={handleOk}>
                            Ok
                        </Button>,
                    ]}>
                    <p>
                        Holds a set of reusable objects for different aspects of the OAS. All objects defined within the components object will have no effect on the API unless they are explicitly
                        referenced from properties outside the components object.
                    </p>
                    <Form form={form} initialValues={initialValues}>
                        <Form.Item
                            name="name"
                            label="Name"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please add name',
                                },
                            ]}>
                            <Input />
                        </Form.Item>
                        <Form.Item name="type" label="Type">
                            <Select style={{width: '100%'}} onChange={handleModelTypeChange}>
                                <Select.Option value="schema">Schema</Select.Option>
                                <Select.Option value="parameter">Parameter</Select.Option>
                                <Select.Option value="securityScheme">Security Scheme</Select.Option>
                            </Select>
                        </Form.Item>
                        {currentModelType === 'schema' && (
                            <Form.Item label="Schema Type" name="schemaType">
                                <Select style={{width: '100%'}} onChange={handleTypeChange}>
                                    {supportedTypes.map((type) => (
                                        <Select.Option value={type}>{type}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        )}
                        {currentType === 'combined' && (
                            <Form.Item label="Combined Schema Operator" name="operator">
                                <Select style={{width: '100%'}}>
                                    <Select.Option value="allOf">allOf</Select.Option>
                                    <Select.Option value="oneOf">oneOf</Select.Option>
                                    <Select.Option value="anyOf">anyOf</Select.Option>
                                </Select>
                            </Form.Item>
                        )}
                    </Form>
                </Modal>
            )}
        </Fragment>
    );
}
